import React, {useContext, useState} from 'react';
import {useTranslation} from 'react-i18next';
import UserContext from "./UserContext";
import { useHistory, useLocation } from 'react-router-dom';
import LogoCatbears from 'components/LogoCatbears/LogoCatbears';
import ButtonCircle from 'components/ButtonCircle/ButtonCircle';
import RegisterMachine from 'components/RegisterMachine/RegisterMachine';
import "./LoginPage.scss"

const LoginToCatbears = ({onLogin, onClose, shouldAllowSwitchToRegister, getIsRegisterMode=false}) => {
  const {user} = useContext(UserContext);
  const history = useHistory();
  const location = useLocation();
  const {t} = useTranslation();
  const [currentMode, setCurrentMode] = useState('login');

  const loginFunc = () => {
    const params = new URLSearchParams(location.search);
    const returnTo = params.get('returnTo');
    if (returnTo) {
      history.replace(returnTo);
      return;
    }
    // Avoid bouncing back to the register page or to nowhere
    try {
      const referrer = document.referrer || '';
      const cameFromRegister = referrer.includes('/register');
      const noHistory = window.history.length <= 1;
      if (cameFromRegister || noHistory) {
        history.replace('/');
      } else {
        history.goBack();
      }
    } catch (_) {
      history.replace('/');
    }
  }

  return (
    <>
      <div className={"Onboarding-content Onboarding-container-no-footer login-page-container hideScrollbar"}>
            <ButtonCircle classes={'ButtonCircle-back ButtonCircle-50px login-page-back'} onClick={() => history.goBack()} />
            <LogoCatbears
              isCentered 
              isTapToLandingPage
              isFixed={false}
            />
            <div className="login-page-form-container">
              <div className="login-page-title">
                {currentMode === 'register' && t('loginFlow.registerToCatbears_title')}
                {currentMode === 'login' && t('loginFlow.loginToCatbears_title')}
                {currentMode === 'forgot' && t('loginFlow.forgotPasswordTitle')}
              </div>
              <div className="login-page-subtitle">
                {currentMode === 'register' && t('loginFlow.registerToCatbears_subtitle')}
                {currentMode === 'login' && t('loginFlow.loginToCatbears_subtitle')}
                {currentMode === 'forgot' && t('loginFlow.forgotPasswordSubtitle')}
              </div>
              <RegisterMachine 
                onSuccess={loginFunc}
                initialMode="login"
                onModeChange={setCurrentMode}
                isBrightMode={true}
              />
            </div>
        <div className='Room'></div>
      </div>
    </>
  )
}


export default LoginToCatbears;




// import React, {useContext, useEffect, useState} from 'react';
// import { useTranslation } from 'react-i18next';
// import setPropertyVh from '../../utils/setPropertyVh';
// import Instructor from '../../components/Instructor/Instructor';
// import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
// import './Onboarding_Register.scss'
// import Catbears_Register from 'pages/Login/Catbears_Register';
// import UserContext from "../../pages/Login/UserContext";
// import Catbears_Login from "../../pages/Login/Catbears_Login";

// const Onboarding_Register = ({
//             // onExit,
//             onBack,
//             onContinue,            
//     }) => {
//     const {t} = useTranslation();
//     setPropertyVh();

//     const loginFunc = () => {user.isGuest && setIsLogin(true)}
//     const {user, handleUserUpdate} = useContext(UserContext);
//     const [isLogin, setIsLogin] = useState(false);
//     const [shouldDisplayLogin, setshouldDisplayLogin] = useState(false); // no

//     const toggleDisplayLogin = () => {
//         setshouldDisplayLogin(!shouldDisplayLogin)
//     }
//     return (
//         <>
//         {/* <Xbutton fixed={true} onClose={onXbutton ? onXbutton : undefined}/> */}
//         <div className={"Onboarding-content Onboarding-container-no-footer"}>
//                     {/* <div className={"Onboarding-title"}>{t("loginFlow.createAnAccount")}</div>
//                     <div className={"Onboarding-subtitle"}>{t("loginFlow.progress-saved")}</div> */}
//                        {shouldDisplayLogin ? 
//                         <Catbears_Login 
//                             onLogin={"onCloseLogin"} 
//                             onClose={"onCloseLogin"} 
//                             shouldAllowSwitchToRegister={false}
//                             toggleDisplayLogin={toggleDisplayLogin}
//                         />
//                         :
//                         <Catbears_Register
//                             shouldDisplayLogin={false}
//                             onSignUp={onContinue}
//                             isSkippable={true}
//                             onSkip={onContinue}
//                             dontShowTitle={true}
//                             hasAccout={loginFunc}
//                             toggleDisplayLogin={toggleDisplayLogin}
//                             // isBright={true}
//                         />
                        
//                         }
//                     <div className='Room'></div>
//                 </div>
//             {/* <div className={"Onboarding-footer"}>
//                 <button onClick={""} className={"button Onboarding-button Onboarding-button-secondary  catbearsCTA-primary Onboarding-button"}>
//                     {t("general.watchVideo")}
//                 </button>          
//                 <button onClick={onContinue} className={"button Onboarding-button Onboarding-button-primary catbearsCTA-secondary"}>
//                     {t("general.watchedAndContinue")}
//                 </button>
//             </div> */}
//         </>
//         )

// }

// export default Onboarding_Register